import React from "react";
import { useI18n } from "../lib/i18n.jsx";

export default function TimeAllocation({ alloc, testid = "time-allocation" }) {
  const { t, tp } = useI18n();
  if (!alloc) return null;
  const un = alloc.unallocated_minutes;
  let msg = null, color = "var(--text-3)";
  if (un !== undefined && un !== null) {
    if (Math.abs(un) < 0.5) { msg = t("alloc_full"); color = "var(--green)"; }
    else if (un > 0) { msg = tp("alloc_missing", { n: Math.round(un) }); color = "var(--amber)"; }
    else { msg = tp("alloc_over", { n: Math.round(-un) }); color = "var(--red)"; }
  }
  return (
    <div className="text-xs text-[var(--text-3)] space-y-0.5" data-testid={testid}>
      <div className="font-mono-num">
        {t("productive_time")}: <b>{alloc.productive_minutes}′</b> · {t("non_productive_time")}: <b>{alloc.non_productive_minutes}′</b>
        {alloc.shift_minutes !== undefined && <> · {t("shift")}: <b>{alloc.shift_minutes}′</b></>}
        {alloc.efficiency !== undefined && <> · {t("efficiency")}: <b>{alloc.efficiency != null ? `${alloc.efficiency}%` : "—"}</b></>}
      </div>
      {msg && <div className="font-semibold" style={{ color }} data-testid={`${testid}-msg`}>{msg}</div>}
    </div>
  );
}
